import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { IRemitenteDestinatario } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { RemitenteService } from "../../../services/catalogos/remitente/remitente.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import {
  selectCatalogoRemitenteStatus
} from "../../../states/admon-catalogos/selector";
import { cargaRemitente } from "../../../states/catalogos/actions";
import {
  emailPatternValidator,
  existeValorDuplicado,
  nombreRemitente
} from "../../utils";
import { AddRemitenteComponent } from "../add-remitente/add-remitente.component";

@Component({
  selector: "app-list-remitentes",
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    AddRemitenteComponent,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./list-remitentes.component.html",
  styleUrl: "./list-remitentes.component.css",
})
export class ListRemitentesComponent {
  private store: Store<AppState> = inject(Store);
  admonCatRemitenteStatus$ = this.store.pipe(
    select(selectCatalogoRemitenteStatus)
  );
  remitentes: IRemitenteDestinatario[] = [];
  remitentesBackup: IRemitenteDestinatario[] = [];
  registroSeleccionado!: IRemitenteDestinatario | null;
  ocultarVistaLectura = false;
  editandoRegistro = false;
  mostrarBotones = true;
  editarForm!: FormGroup;
  existe = false;
  filtroNombre: string = "";

  constructor(
    private remitenteService: RemitenteService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadingService.show();
    this.editarForm = this.fb.group({
      nombre: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          nombreRemitente(),
        ],
      ],
      apellido: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          nombreRemitente(),
        ],
      ],
      mail: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          emailPatternValidator(),
        ],
      ],
    });

    this.remitenteService.cargarRemitentes().subscribe(
      (response) => {
        this.remitentes = response;
        this.remitentesBackup = response;
        console.log("Remitentes cargadas:", this.remitentes);
        this.loadingService.hide();
        console.log("Cargamos remitentes en app store");
        this.store.dispatch(cargaRemitente({ catRemitente: response }));
      },
      (error) => {
        this.loadingService.hide();
        console.error("Error al cargar empresas:", error);
      }
    );
  }

  editarRegistro(remitente: IRemitenteDestinatario | null): void {
    this.registroSeleccionado = remitente;
    this.editandoRegistro = true;
    this.editarForm.setValue({
      nombre: remitente?.nombre || "",
      mail: remitente?.mail,
      apellido: remitente?.apellido,
    });
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "remitentes",
        mostrarEditar: true,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  cancelarEdicion() {
    this.editandoRegistro = false;
    this.editarForm.setValue({
      nombre: "",
      mail: "",
      apellido: "",
    });
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "remitentes",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  guardarCambios(data: IRemitenteDestinatario) {
    this.loadingService.show();
    console.log("");
    console.log("Comentario guardado:", this.editarForm.value.nombre);

    if (this.editarForm.valid) {
      this.remitenteService
        .editarRemitente({
          ...data,
          nombre: this.editarForm.value.nombre,
          apellido: this.editarForm.value.apellido,
          mail: this.editarForm.value.mail,
        })
        .subscribe((data) => {
          console.log("data", data);
          this.loadingService.hide();
          this.cancelarEdicion();
        });
    }
  }
  eliminarRemitente(remitente: IRemitenteDestinatario): void {
    this.loadingService.show();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Advertencia",
        message: "¿Estás seguro que quieres eliminar el item?",
        showButtons: {
          accept: true,
          cancel: true,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "CONFIRMAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      console.log("Acción confirmada");
      this.remitenteService
        .eliminarRemitente(remitente.id)
        .subscribe((data) => {
          console.log("data", data);
          this.loadingService.hide();
        });
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {
      console.log("Acción cancelada");
      this.loadingService.hide();
    });
  }

  existeRegistro(control: any, emailActual: any): void {
    existeValorDuplicado(control, this.remitentes, emailActual);
  }

  search(event: any) {
    const filtro = event.target.value
      ? event.target.value.toLowerCase().trim()
      : "";

    if (filtro === "" && !filtro) {
      this.remitentes = [...this.remitentesBackup];
    } else {
      this.remitentes = this.remitentesBackup.filter(
        (remitente) =>
          (remitente.nombre &&
            remitente.nombre.toLowerCase().includes(filtro)) ||
          (remitente.apellido &&
            remitente.apellido.toLowerCase().includes(filtro)) ||
          (remitente.mail && remitente.mail.toLowerCase().includes(filtro))
      );
    }
  }
  newRemitente() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "remitentes",
        mostrarEditar: false,
        mostrarNuevo: true,
        guardando: false,
      })
    );
  }
}
